<template>
  <div>
    <b-button @click="showModal = true" variant="info">{{ buttonText }}</b-button>
    <b-modal v-model="showModal" centered :title="modalTitle" hide-footer>
      <validation-observer ref="observer">
        <b-form @submit.prevent="validateBeforeUpload">
          <b-form-group>
            <validation-provider :name="inputLabel" :rules="validationRules" v-slot="{ errors }">
              <b-form-file
                :accept="acceptedFileTypes"
                v-model="selectedFile"
                :state="errors.length ? false : null"
              ></b-form-file>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <b-button variant="primary" type="submit">{{ submitText }}</b-button>
          <b-button variant="secondary" @click="cancelUpload">{{ cancelText }}</b-button>
        </b-form>
      </validation-observer>
    </b-modal>
  </div>
</template>

<script>
import {
  BModal,
  BFormFile,
  BButton,
  BFormGroup,
  BForm
} from 'bootstrap-vue'
import {
  ValidationObserver,
  ValidationProvider,
  extend,
  localize
} from 'vee-validate'
import { required } from 'vee-validate/dist/rules'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import api from '../../services/api'

// Register validation rules
extend('required', required)

extend('image_or_pdf', {
  validate: (file) => {
    if (!file) return false
    const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'application/pdf']
    return allowedTypes.includes(file.type)
  },
  message: 'الملف يجب أن يكون صورة أو PDF'
})

export default {
  components: {
    BModal,
    BForm,
    BFormFile,
    BButton,
    BFormGroup,
    ValidationObserver,
    ValidationProvider
  },

  props: {
    basePath: {
      type: String,
      required: true
    },
    recordId: {
      type: [Number, String],
      required: true
    },
    fileFieldName: {
      type: String,
      default: 'File'
    },
    acceptedFileTypes: {
      type: String,
      default: 'image/*,application/pdf'
    },
    validationRules: {
      type: String,
      default: 'required|image_or_pdf'
    },
    inputLabel: {
      type: String,
      default: 'الملف'
    },
    modalTitle: {
      type: String,
      default: 'اضافة مرفق'
    },
    buttonText: {
      type: String,
      default: 'اضافة مرفق'
    },
    submitText: {
      type: String,
      default: 'اضافة'
    },
    cancelText: {
      type: String,
      default: 'الغاء'
    },
    successMessage: {
      type: String,
      default: 'تم تحميل الملف بنجاح'
    },
    errorMessage: {
      type: String,
      default: 'حدث خطأ أثناء تحميل الملف'
    }
  },

  data() {
    return {
      locale: 'ar',
      showModal: false,
      selectedFile: null
    }
  },

  mounted() {
    localize(this.locale)
  },

  computed: {
    fullUploadUrl() {
      return `${this.basePath}/${this.recordId}`
    }
  },

  methods: {
    async validateBeforeUpload() {
      const isValid = await this.$refs.observer.validate()
      if (isValid) {
        this.uploadFile()
      }
    },

    async uploadFile() {
      const formData = new FormData()
      formData.append(this.fileFieldName, this.selectedFile)

      try {
        await api.post(this.fullUploadUrl, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })

        this.$emit('upload-success')

        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.successMessage,
            icon: 'CheckIcon',
            variant: 'success'
          }
        })
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.errorMessage,
            icon: 'XCircleIcon',
            variant: 'danger'
          }
        })
      }

      this.showModal = false
      this.selectedFile = null
    },

    cancelUpload() {
      this.showModal = false
      this.selectedFile = null
    }
  }
}
</script>
